{
  "navigation.title": "What's new across Atlassian",
  "app.updates.title": "What's new across Atlassian",
  "app.updates.subtitle": "Discover new cloud features designed to unleash your team's potential and see how our latest updates can power your work today.",
  "app.updates.browserTabTitle": "Release Notes | Atlassian Community",
  "appUpdatesDetails.backAction": "Back to release notes",
  "appUpdatesDetails.browserTabTitleSuffix": "Release Notes | Atlassian Community",
  "appUpdatesDetails.notFound": "This release note could not be found. Use the back button to return to release notes.",
  "appUpdatesDetails.error": "Unable to load this release note. Use the back button to return and try again.",
  "appUpdatesDetails.loading": "Loading release note\u2026",
  "appUpdatesDetails.summary": "Summary",
  "appUpdatesDetails.keyChanges": "Key changes",
  "appUpdatesDetails.benefits": "Benefits",
  "appUpdatesDetails.reasonForChange": "Reason for the change",
  "appUpdatesDetails.prepareForChange": "How to prepare for the change",
  "appUpdatesDetails.getStarted": "Getting started",
  "appUpdatesDetails.changelog.release": "Release",
  "appUpdatesDetails.changelog.scheduledStatus": "Scheduled",
  "appUpdatesDetails.changelog.rollingOutStatus": "Rolling Out",
  "appUpdatesDetails.changelog.completedStatus": "Completed",
  "appUpdatesDetails.sidebar.appsImpactedTitle": "Apps impacted"
}
